document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("saber-builder")) return;

  const builder = document.querySelector("#saber-builder");
  if (!builder) return;

  const baseUrl = "https://cdn.shopify.com/s/files/1/0610/0933/0410/files/";
  const partKeys = ["pommel", "grip", "switch", "emitter"];

  // 1) NA SVE FORME DODAJ HIDDEN PROPERTIES
  function addInputsToForm(form) {
    partKeys.forEach((p) => {
      const label = p.charAt(0).toUpperCase() + p.slice(1); // Pommel
      if (!form.querySelector(`input[name="properties[${label}]"]`)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${label}]`;
        input.value = "Not selected";
        form.appendChild(input);
      }
    });
  }

  // inicijalno
  let productForms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  productForms.forEach(addInputsToForm);

  // 2) AK SE POJAVE NOVE FORME (sticky/drawer/section) – DODAJ I NA NJIH
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        // ako je baš form
        if (node.matches && node.matches('form[action*="/cart/add"]')) {
          addInputsToForm(node);
          productForms.push(node);
        } else {
          // ili sadrži formu
          const innerForms = node.querySelectorAll
            ? node.querySelectorAll('form[action*="/cart/add"]')
            : [];
          if (innerForms.length) {
            innerForms.forEach((f) => {
              addInputsToForm(f);
              productForms.push(f);
            });
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function setValueOnAllForms(partKey, value) {
    const label = partKey.charAt(0).toUpperCase() + partKey.slice(1);
    productForms.forEach((form) => {
      const inp = form.querySelector(`input[name="properties[${label}]"]`);
      if (inp) inp.value = value;
    });
  }

  // 3) FADE HELPER
  const fadeSwap = (imgEl, newSrc) => {
    imgEl.style.transition = "opacity 0.25s ease-in-out";
    imgEl.style.opacity = 0;
    setTimeout(() => {
      imgEl.src = newSrc;
      imgEl.onload = () => (imgEl.style.opacity = 1);
    }, 200);
  };

  // 4) KLIK NA MODEL
  document.querySelectorAll(".model-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const wrapper = btn.closest(".variant-wrapper");
      const part = wrapper.dataset.part; // "pommel" ...

      const modelsRow = btn.closest(".models-row");
      modelsRow.querySelectorAll(".model-btn").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const sub = btn.closest(".sub-variant");
      modelsRow.querySelectorAll(".sub-variant").forEach((v) => v.classList.remove("open"));
      sub.classList.add("open");

      // npr. "Pommel 323"
      const value = btn.textContent.trim().replace(/\s+/g, " ");
      document.body.dataset[part] = value;

      // upiši u SVE forme
      setValueOnAllForms(part, value);
    });
  });

  // 5) KLIK NA SWATCH
  document.querySelectorAll(".swatch").forEach((swatch) => {
    swatch.addEventListener("click", () => {
      const wrap = swatch.closest(".color-wrap");
      const part = wrap.dataset.part;   // "pommel"
      const model = wrap.dataset.model; // "323"
      const imgName = swatch.dataset.img;
      const imgUrl = baseUrl + imgName;

      // mali preview
      const preview = document.querySelector(
        `.preview-img[data-part='${part}'][data-model='${model}']`
      );
      if (preview) fadeSwap(preview, imgUrl);

      // glavna slika
      const mainImg = document.querySelector(`.${part}img img`);
      if (mainImg) fadeSwap(mainImg, imgUrl);

      // active swatch
      wrap.querySelectorAll(".swatch").forEach((s) => s.classList.remove("active"));
      swatch.classList.add("active");

      const colorLabel = (swatch.getAttribute("title") || "").trim();
      const current = document.body.dataset[part] || `${part} ${model}`;
      const base = current.split("–")[0].trim();
      const finalValue = `${base} – ${colorLabel}`;

      document.body.dataset[part] = finalValue;
      setValueOnAllForms(part, finalValue);
    });
  });

  // 6) OTVARANJE BLOKOVA
  document.querySelectorAll(".buildttl").forEach((ttl) => {
    ttl.addEventListener("click", () => {
      const wrap = ttl.closest(".variant-wrapper");
      document.querySelectorAll(".variant-wrapper").forEach((w) => {
        if (w !== wrap) w.classList.remove("open");
      });
      wrap.classList.toggle("open");
    });
  });
});
